<template lang="pug">
.container-fluid(v-if="contrato")
	.row
		.col-xs-12.col-sm-12.col-md-12.col-lg-3.col-xl-3
			.card.mb-2(v-if="contrato.FechaEliminado")
				.card-body.bg-danger.text-white
					span.fa.fa-trash.mr-2.float-right(style="font-size:4.5em;opacity:0.3;")
					h4
						b Contrato eliminado
					| Eliminado por {{contrato.UsuarioEliminadoNombre}}
					br
					| el {{contrato.FechaEliminado | moment('DD-MM-YYYY')}} a las {{contrato.FechaEliminado | moment('hh:mm:ss')}}

				.card-body.bg-success.text-white(v-if="finalizado && !contrato.FechaEliminado")
					span.fa.fa-check.mr-2.float-right(style="font-size:4.5em;opacity:0.3;")
					h4
						b Contrato finalizado

			.card
				.card-header.bg-info.text-white
					span.fa.fa-info.mr-2
					| Información
				.card-body.bg-light
					div(style="display:table-row")
						div.text-center(style="display:table-cell;width:50px;")
							avatar(:usuario="contrato.AgenteID", :avatar="contrato.AgenteAvatar", :width="70")
						div.text-left.p-2(style="display:table-cell;vertical-align:middle;font-size:1.3em;font-weight:bold;")
							span.text-danger Agente
							br
							| {{contrato.AgenteNombre}}
				.card-body
					span.fa.fa-info-circle.mr-2
					b Datos generales
				table.table.table-striped.m-0
					tbody
						tr
							td Fecha de creación
							td {{contrato.FechaCreacion | moment('DD-MM-YYYY')}} a las {{contrato.FechaCreacion | moment('HH:mm:ss')}}
						tr
							td Creado por
							td {{contrato.UsuarioNombre}}
						tr(v-if="!contrato.FechaModificacion")
							td Fase candidato
							td
								span(v-if="contrato.FechaCandidato")
									| {{contrato.FechaCandidato | moment('DD-MM-YYYY')}} a las {{contrato.FechaCandidato | moment('hh:mm:ss')}}
									br
									| {{contrato.UsuarioCandidatoNombre}}
								span(v-else)
									button.btn.btn-primary(v-if="contrato.AgenteID === usuario.ID || permisos.contratos_crearAjenos", @click="setCandidato")
										| Convertir en candidato
						tr.text-danger(v-else)
							td Contrato descartado
							td
								| {{contrato.FechaModificacion | moment('DD-MM-YYYY')}} a las {{contrato.FechaModificacion | moment('hh:mm:ss')}}
						tr.bg-warning(v-if="contrato.Estado === 'Candidato' && !hayFirma && permisos.contratos_firmaManuscrita")
							td.text-center(colspan="2")
								span.fa.fa-edit(style="font-size:2em;")
								p Firmar digitalmente
								button.btn.btn-sm.btn-dark(@click="firmar")
									span.fa.fa-pencil.mr-2
									| Firmar
						tr(v-if="!contrato.FechaAprobado && !contrato.FechaRechazado && contrato.FechaCandidato && permisos.contratos_aprobar && hayFirma")
							td
							td
								button.btn.btn-sm.btn-success.m-1(@click="setAprobado")
									| Aprobar
								button.btn.btn-sm.btn-danger.m-1(@click="setRechazado")
									| Rechazar
						tr(v-if="!hayFirma && contrato.Estado === 'Candidato'")
							td.bg-danger.text-white.text-center(colspan="2")
								span.fa.fa-exclamation-triangle(style="font-size:2em;")
								p Adjuntar contrato firmado en pdf
								button.btn.btn-sm.btn-dark(@click="upload(true)", v-if="!hayFirma && contrato.Estado === 'Candidato'")
									span.fa.fa-edit.mr-2
									| Subir firma
						tr.text-success(v-if="contrato.FechaAprobado")
							td Aprobado
							td
								| {{contrato.FechaAprobado | moment('DD-MM-YYYY')}} a las {{contrato.FechaAprobado | moment('hh:mm:ss')}}
								br
								| {{contrato.UsuarioAprobadoNombre}}
						tr.text-danger(v-if="contrato.FechaRechazado")
							td Rechazado
							td
								| {{contrato.FechaRechazado | moment('DD-MM-YYYY')}} a las {{contrato.FechaRechazado | moment('hh:mm:ss')}}
								br
								| {{contrato.UsuarioRechazadoNombre}}
						tr.text-danger(v-if="contrato.FechaBloqueado")
							td Bloqueado
							td
								p Este contrato está bloqueado por <b>{{contrato.UsuarioBloqueaNombre}}</b> debido a un traspaso de cartera.
								p <b>No se podrá modificar</b>
				.card-footer
					button.btn.btn-primary.m-1(@click="imprimir = true")
						span.fa.fa-print
					a.btn.btn-warning.m-1(ref="linkDescarga", download="Contrato.pdf", :href="'/src/modulos/mis-contratos/php/api/get-pdf-contrato.php?ContratoID=' + contrato.ContratoID")
						span.fa.fa-file-pdf-o
					button.btn.btn-warning.m-1(@click="editar" v-if="!contrato.FechaBloqueado")
						span.fa.fa-edit
					button.btn.btn-danger.m-1(@click="setEliminado", v-if="eliminable")
						span.fa.fa-trash
			.card.mt-3
				.card-header
					span.fa.fa-list.mr-2
					| Ficheros
				table.table.table-striped.m-0
					tbody
						tr(
							v-for="fichero in contrato.ficheros"
							:key="fichero.FicheroID"
							:class="(fichero.EsContratoFirmado) ? 'bg-warning' : ''"
						)
							td.p-1.pl-2(style="vertical-align:middle;")
								span.fa.fa-edit.mr-2(v-if="fichero.EsContratoFirmado")
								.truncate-text(:title="fichero.Nombre") {{fichero.Nombre}}
								span.ml-2(style="opacity:0.5") {{fichero.Tamano | tamano}}
							td.p-1
								a.btn.m-1.btn-sm.btn-primary(v-if="fichero.Extension.toLowerCase() === 'pdf'" target="_blank", :href="'/src/modulos/mis-contratos/php/api/ficheroVer.php?FicheroID=' + fichero.FicheroID")
									span.fa.fa-eye
								a.btn.m-1.btn-sm.btn-success(v-if="fichero.Extension.toLowerCase() !== 'pdf'" target="_blank", :href="'/src/modulos/mis-contratos/php/api/ficheroDownload.php?FicheroID=' + fichero.FicheroID")
									span.fa.fa-download
								button.btn.m-1.btn-sm.btn-danger(
									@click="eliminarFichero(fichero)"
									v-if="permisoBorrarFichero(fichero)"
								)
									span.fa.fa-trash
				.card-body.text-center(v-if="!contrato.ficheros || contrato.ficheros.length === 0")
					h4 No hay ficheros
				.card-footer
					.row
						.col
							button.btn.btn-sm.btn-warning(@click="upload(false)")
								span.fa.fa-upload.mr-2
								| Subir fichero
						.col.text-right
							button.btn.btn-sm.btn-danger(@click="upload(true)")
								span.fa.fa-upload.mr-2
								| Subir otra firma

			.card.mt-3
				.card-header.bg-warning
					span.fa.fa-list.mr-2
					| Historial de ediciones
				table.table.table-striped.m-0
					tbody
						tr(v-for="edicion in contrato.historico", :key="edicion.ContratoID", :class="(ContratoID === edicion.ContratoID) ? 'bg-dark text-white' : ''")
							td {{edicion.UsuarioNombre}}
							td {{edicion.FechaCreacion | moment('DD-MM-YYYY')}} a las {{edicion.FechaCreacion | moment('HH:mm:ss')}}
							td
								router-link.btn.btn-primary.btn-sm(:to="'/main/contratos/listado/' + edicion.ContratoID")
									span.fa.fa-eye



		.col-xs-12.col-sm-12.col-md-12.col-lg-9.col-xl-9
			detalles-contrato(:contrato="contrato", @actualizar="getContrato")
	imprimir(v-if="imprimir", @cerrar="imprimir = null", @imprimir="goImprimir($event)", :color="true", :dobleCara="true", impresora="Comercial")
	firmar(v-if="verFirma", :contrato="contrato", @cerrar="verFirma = false", @firmado="contratoFirmado()")
</template>

<style>
.truncate-text {
    max-width: 310px; /* Ajusta el ancho máximo según tus necesidades */
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

</style>

<script>
import API from '../../services/api'
import { mapGetters } from 'vuex'
import DetallesContrato from './detalles-contrato'
import Firmar from './modalFirma'
import axios from 'axios'
export default {
	props: ['ContratoID'],
	components: {
		'detalles-contrato': DetallesContrato,
		'firmar': Firmar
	},
	data () {
		return {
			imprimir: null,
			contrato: null,
			verFirma: false,
			firmaManuscrita: null
		}
	},
	created () {
		if (!this.ContratoID) {
			this.$error('Error', 'Debes proporcionar el ID de contrato')
			return
		}
		this.getContrato()
	},
	watch: {
		ContratoID: function (id) {
			this.getContrato()
		}
	},
	computed: {
		...mapGetters({
			usuario: 'session/usuario',
			permisos: 'permisos/permisos'
		}),
		hayFirma () {
			return this.contrato.ficheros.reduce((ant, actual) => {
				if (actual.EsContratoFirmado) {
					ant = true
				}
				return ant
			}, false)
		},
		/**
		 * Determina si un contrato es eliminable.
		 * Para ello el contrato debe estar en fase borrador y
		 * no tener recibos ni facturación en periodos cerrados
		 */
		eliminable () {
			return true
		},
		/**
		 * Determina si un contrato está finalizado o no.
		 * Para ello la fecha de fin de contrato debe ser anterior a la actual
		 */
		finalizado () {
			if (!this.contrato) {
				return false
			}
			return (this.contrato.FechaFin <= new Date())
		}
	},
	methods: {
		getContrato () {
			if (this.ContratoID) {
				API.getContrato(this.ContratoID)
					.then(res => {
						this.contrato = res
					})
					.catch(e => {
						this.$store.commit('alertas/error', {
							titulo: 'Error',
							mensaje: e.response.data.error
						})
					})
			}
		},
		setCandidato () {
			this.$store.commit('alertas/confirm', {
				titulo: 'Convertir en candidato',
				mensaje: `¿Quieres convertir este contrato en candidato?`,
				callback: acepta => {
					if (acepta) {
						API.setCandidato(this.contrato.ContratoID)
							.then(res => {
								this.getContrato()
							})
							.catch(e => {
								this.$store.commit('alertas/error', {
									titulo: 'Error',
									mensaje: e.response.data.error
								})
							})
					}
				}
			})
		},
		setAprobado () {
			this.$store.commit('alertas/confirm', {
				titulo: 'Aprobar contrato',
				mensaje: `¿Quieres aprobar este contrato?`,
				callback: acepta => {
					if (acepta) {
						API.setAprobar(this.contrato.ContratoID)
							.then(res => {
								this.getContrato()
							})
							.catch(e => {
								this.$store.commit('alertas/error', {
									titulo: 'Error',
									mensaje: e.response.data.error
								})
							})
					}
				}
			})
		},
		setRechazado () {
			this.$store.commit('alertas/confirm', {
				titulo: 'Rechazar contrato',
				mensaje: `¿Quieres rechazar este contrato?`,
				callback: acepta => {
					if (acepta) {
						API.setRechazar(this.contrato.ContratoID)
							.then(res => {
								this.getContrato()
							})
							.catch(e => {
								this.$store.commit('alertas/error', {
									titulo: 'Error',
									mensaje: e.response.data.error
								})
							})
					}
				}
			})
		},
		setEliminado () {
			this.$store.commit('alertas/confirm', {
				titulo: 'Eliminar contrato',
				mensaje: `¿Quieres eliminar este contrato?`,
				callback: acepta => {
					if (acepta) {
						API.setEliminado(this.contrato.ContratoID)
							.then(res => {
								this.getContrato()
							})
							.catch(e => {
								this.$store.commit('alertas/error', {
									titulo: 'Error',
									mensaje: e.response.data.error
								})
							})
					}
				}
			})
		},
		firmar () {
			this.verFirma = true
		},
		permisoBorrarFichero (fichero) {
			const tiempoLimite = new Date().getTime() - 86400000
			if (fichero.EsContratoFirmado) {
				if (!this.permisos.contratos_eliminaFirma) {
					return false
				} else if (fichero.FechaSubidoUnix * 1000 < tiempoLimite) {
					return false
				} else if (this.contrato.AgenteID !== this.usuario.ID && !this.permisos.contratos_crearAjenos) {
					return false
				} else {
					return true
				}
			} else if (this.contrato.AgenteID !== this.usuario.ID && !this.permisos.contratos_crearAjenos) {
				return false
			}
			return true
		},
		editar () {
			this.$store.commit('alertas/confirm', {
				titulo: 'Editar contrato',
				mensaje: `Cuando editar un contrato generarás una copia del mismo, quedando éste como parte de su histórico.
				¿Quieres continuar?`,
				callback: acepta => {
					if (acepta) {
						this.$router.push('/main/contratos/editar/' + this.ContratoID)
					}
				}
			})
		},
		goImprimir (opciones) {
			const form = {
				OpcionesImpresion: opciones,
				Contrato: this.contrato.ContratoID,
				imprimir: true
			}

			axios.post('mis-contratos/php/api/get-pdf-contrato.php?ContratoID=' + this.contrato.ContratoID, form)
				.then(res => {
					this.$store.commit('toast/success', {
						titulo: 'Impresión iniciada'
					})
				})
				.catch(this.$responseError)
		},
		eliminarFichero (fichero) {
			this.$store.commit('alertas/confirm', {
				titulo: 'Eliminar fichero',
				mensaje: '¿Quieres eliminar este fichero?\nEsta acción no la podrás deshacer',
				callback: acepta => {
					if (acepta) {
						this.$http.delete('mis-contratos/php/api/ficheroDel.php?FicheroID=' + fichero.FicheroID)
							.then(res => {
								this.getContrato()
								this.$store.commit('toast/success', {
									titulo: 'Fichero eliminado'
								})
							})
							.catch(this.$responseError)
					}
				}
			})
		},
		contratoFirmado () {
			this.verFirma = false
			this.getContrato()
		},
		upload (esFirma) {
			const inp = document.createElement('input')
			inp.type = 'file'
			inp.multiple = true
			inp.accept = 'application/pdf'
			inp.addEventListener('change', () => {
				document.body.removeChild(inp)

				// Creamos el form
				const form = new FormData()
				for (let i = 0; i < inp.files.length; i++) {
					form.append('fichero[]', inp.files[i])
				}
				form.append('EsContratoFirmado', esFirma)
				form.append('ContratoID', this.contrato.ContratoID)

				const ajax = new XMLHttpRequest()
				ajax.open('POST', '/src/modulos/mis-contratos/php/api/ficheroAdd.php?ContratoID=' + this.contrato.ContratoID)
				ajax.onreadystatechange = () => {
					if (ajax.readyState === 4) {
						if (ajax.status === 200) {
							this.getContrato()
						} else {
							let mensaje
							try {
								mensaje = JSON.parse(ajax.responseText)
							} catch (e) {
								mensaje = {error: 'Error desconocido'}
							}
							this.$store.commit('alertas/error', {
								titulo: 'Error',
								mensaje: mensaje.error
							})
						}
					}
				}

				ajax.send(form)
			})

			document.body.appendChild(inp)
			inp.click()
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/modulos/mis-contratos/vue/components/visor-contrato/visor-contrato.vue